import React, { useContext } from 'react';
import { MantyStatus } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/constants';

type MantyStatusEnvelopeMantyStatusHypothesesChangesContextT = {
    hasChanges: boolean;
    setHasChanges: React.Dispatch<React.SetStateAction<boolean>>;
    nonRecurrentEnvelopeStatuses: MantyStatus[];
};

const EnvelopeMantyStatusHypothesesChangesContext =
    React.createContext<MantyStatusEnvelopeMantyStatusHypothesesChangesContextT>(
        {
            hasChanges: false,
            setHasChanges: () => {},
            nonRecurrentEnvelopeStatuses: [],
        },
    );

export const useEnvelopeMantyStatusHypothesesChangesContext = () =>
    useContext(EnvelopeMantyStatusHypothesesChangesContext);

export default EnvelopeMantyStatusHypothesesChangesContext;
